import React from 'react';
import { Segment, Button, Icon, Form, Message } from 'semantic-ui-react'

/**
 * Import from Excel
 */
export default class Import extends React.Component {

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
			uiData: {}
        }
    }	

    /**
     * List attached files
     */
    listAttachedFiles(event) {
        // Get info
        console.log('New filename ' + event.target.value + ', total files: ' + event.target.files.length);
        console.log(event.target.files[0]);

        this.setState({ uiData: { ...this.state.uiData, attachment: event.target.files[0] } } );

        this.props.importFile(event.target.files[0]);
    }  

	render() {
		return  <Segment basic loading={ this.props.isProcessing }>
					<h3><Icon name='upload'/>Import</h3>
                    { this.props.error === undefined ? '' : <Message error>Hiba történt. { this.props.error }</Message> }
					<Message warning>Új feltöltés nem zárja le a folyamatban levő igényeket, de felülírja a korábban importált Excel tartalmát.</Message>
					<Message info>Feltöltés előtt ellenőrizd az Excel fájl szerkezeti helyességét és a pecsétszámok meglétét (<i>Teljes törzs</i>, B oszlop, <i>LIC_HUN_HCP_</i><b>PECSÉTSZÁM</b>). Az első három sheet egyikén sem fogadunk el üres cellát.</Message>
					<Form>
						<Button as="label" primary htmlFor="import.file" type="button"><Icon name='attach'/> VEEVA Excel feltöltése</Button>
						<input onChange={ (event) => this.listAttachedFiles(event) } hidden={ true } type="file" id="import.file" />
						{
							this.state.uiData.attachment !== undefined
							?
							<span>
								<Icon name='file outline'/> { this.state.uiData.attachment.name } { this.props.lastUploadedAttachmentId === undefined ? '' : <Icon name='check'/> }
							</span>
							:
							''
						}
					</Form>
				</Segment>
	}
}